__turbopack_context__.v({
  "ctaWrapper": "HeroSection-module__irrVkW__ctaWrapper",
  "description": "HeroSection-module__irrVkW__description",
  "desktopImage": "HeroSection-module__irrVkW__desktopImage",
  "eyebrow": "HeroSection-module__irrVkW__eyebrow",
  "headline": "HeroSection-module__irrVkW__headline",
  "mobileImage": "HeroSection-module__irrVkW__mobileImage",
  "outOfStockCta": "HeroSection-module__irrVkW__outOfStockCta",
  "productInner": "HeroSection-module__irrVkW__productInner",
  "productWrapper": "HeroSection-module__irrVkW__productWrapper",
  "section": "HeroSection-module__irrVkW__section",
  "textBlock": "HeroSection-module__irrVkW__textBlock",
});
